import { Container } from '../../lib/di';
import { RichText, IRichTextRenderOption } from './rich-text';
import { RichTextSelectionService } from './rich-text.selection';
import { IText } from '../domain/text';
import { IRichTextEditorService, IEditorState } from './rich-text.editor.header';
import { RichTextEditorService } from './rich-text.editor';
import { RichTextEditorKeyboardBindings } from './rich-text.editor.keyboard-bindings';
import { RichTextEditorMouseBindings } from './rich-text.editor.mouse-bindings';
import { RichTextEditorStyleResolver } from './rich-text.editor.style-resolver';

export const enum T {
    RICH_TEXT,
    RICH_TEXT_EDITOR_SERVICE,
    RICH_TEXT_EDITOR_KEYBOARD_BINDINGS,
    RICH_TEXT_EDITOR_MOUSE_BINDINGS,
    RICH_TEXT_EDITOR_STYLE_RESOLVER,
    RICH_TEXT_SELECTION_SERVICE,
    RICH_TEXT_FACTORY,
    NG_ZONE,
    HOTKEY_SERVICE,
    ACTION_RECORDER_SERVICE,
    EDITOR_STATE,
}

export const container = new Container<T>();
export type RichTextFactory = (text: IText, rootElement: HTMLDivElement, options: IRichTextRenderOption) => RichText;

container.register(T.RICH_TEXT, RichText);

container.registerFactory<RichTextFactory>(T.RICH_TEXT_FACTORY, (container) => {
    return (text: IText, rootElement: HTMLDivElement, options: IRichTextRenderOption): RichText => {
        let richText: RichText;
        if (process.env.STUDIO_JS) {
            const richTextEditorService = container.resolve<IRichTextEditorService>(T.RICH_TEXT_EDITOR_SERVICE);
            const editorState = container.tryResolve<IEditorState>(T.EDITOR_STATE);
            richText = new RichText(text, rootElement, options, editorState, richTextEditorService);
            (richTextEditorService as any).text = richText;
        }
        else {
            richText = new RichText(text, rootElement, options);
        }
        return richText;
    };
});

export const createRichText = container.resolve<RichTextFactory>(T.RICH_TEXT_FACTORY);
